import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Smartphone, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { normalizeSaudiPhone, SAUDI_PHONE_ERROR } from "../lib/phone";

// Mandatory phone-collection gate: shown after Google signup for new company accounts
// that have no verified Saudi mobile number yet. Non-dismissable.
export default function PhoneGate() {
  const { setUser, logout } = useAuth();
  const [phone, setPhone] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    const canon = normalizeSaudiPhone(phone);
    if (!canon) { toast.error(SAUDI_PHONE_ERROR); return; }
    setBusy(true);
    try {
      const u = await api.completePhone(canon);
      setUser(u);
      toast.success("تم حفظ رقم الجوال");
    } catch (e) {
      toast.error(e?.response?.data?.detail || SAUDI_PHONE_ERROR);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 font-body" dir="rtl">
      <Dialog open onOpenChange={() => {}}>
        <DialogContent
          className="sm:max-w-sm font-body [&>button]:hidden"
          dir="rtl"
          data-testid="phone-gate-dialog"
          onInteractOutside={(e) => e.preventDefault()}
          onEscapeKeyDown={(e) => e.preventDefault()}>
          <DialogHeader className="text-right">
            <DialogTitle className="font-heading text-xl flex items-center gap-2">
              <Smartphone className="h-5 w-5 text-emerald-600" /> أكمل رقم جوالك
            </DialogTitle>
            <DialogDescription className="text-right">
              لإكمال إنشاء حساب شركتك، أدخل رقم جوال سعودي صحيح. هذا الرقم مطلوب للدخول والتواصل.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-3">
            <div className="space-y-1.5">
              <Label htmlFor="gate-phone">رقم الجوال</Label>
              <Input id="gate-phone" data-testid="phone-gate-input" dir="ltr" inputMode="tel"
                placeholder="05xxxxxxxx" value={phone}
                onChange={(e) => setPhone(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && submit()} />
            </div>
            <Button data-testid="phone-gate-submit" disabled={busy} onClick={submit}
              className="w-full bg-emerald-600 hover:bg-emerald-700 gap-1.5">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Smartphone className="h-4 w-4" />} حفظ ومتابعة
            </Button>
            <button type="button" data-testid="phone-gate-logout" onClick={logout}
              className="w-full text-center text-xs text-slate-400 hover:text-slate-600 transition">
              تسجيل الخروج
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
